// 最新活动
import request from '@/utils/request'

//主页
export function queryAllPromotionType() {
    return request.post('/front/content/queryAllPromotionType')
}

export function queryPromotionByTypeId(id) {
    return request.post('/front/content/queryPromotionByTypeId?id=' + id)
}

//根据产品id查询产品
export function queryProductById(id) {
    return request.post('/product/queryProductById?id=' + id)
}

//查询活动产品关系列表
export function queryPromotionProductById(id) {
    return request.post('/promotion/queryPromotionProductById?id=' + id)
}